import Component from "../../lib/component";
import {getWindowOrientation, ProfileBannerSpace} from "./profile_banner_space";

export const ProfileBannerConfig = {
    componentTypeKey: 'ProfileBanner',
    baseHtmlClass: 'profile_banner',
    selector: '.profile_banner',

    datasetConfigKey: 'profile_banner__config',

};


export class ProfileBanner extends Component {
    
    static get config() {
        return ProfileBannerConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: ProfileBanner.config
        });

        this.setDatasetConfig(ProfileBanner.config.datasetConfigKey);

        this.space = getSpace(this);

        this.render();
    }


    render() {
        const orientation = getWindowOrientation();
        this.conditionallySetHtmlClassState(orientation === ProfileBannerSpace.config.landscapeOrientation, ProfileBannerSpace.config.landscapeOrientation);
        this.conditionallySetHtmlClassState(orientation === ProfileBannerSpace.config.portraitOrientation, ProfileBannerSpace.config.portraitOrientation);
        if(this.space) this.space.render();
    }
}

function getSpace(profileBanner) {
    const element = profileBanner.element.querySelector(ProfileBannerSpace.config.selector);
    if (element) return new ProfileBannerSpace(element, profileBanner);
}

